import { render, staticRenderFns } from "./BaseAddress.vue?vue&type=template&id=4dd0973f&scoped=true"
import script from "./BaseAddress.vue?vue&type=script&lang=js"
export * from "./BaseAddress.vue?vue&type=script&lang=js"
import style0 from "./BaseAddress.vue?vue&type=style&index=0&id=4dd0973f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd0973f",
  null
  
)

export default component.exports